import React, {useEffect, useState} from "react";
import {Button, Col, Row, Select, Typography} from "antd";
import {useTranslation} from "react-i18next";
import {DeleteOutlined} from "@ant-design/icons";


const {Text} = Typography;

const {Option} = Select;

export const ItemMarks = ({
                            data,
                            disabledInput,
                            headerTitle,
                            footerVisible,
                            span,
                            addLessonFooterVisibleHandler,
                            item,
                            handleEditRating,
                            canDelete,
                            handleDeleteRating,
                            headerColor,
                            type,
                            selectedSpecialityId
                          }:any) => {
  const [checkValue, setCheckValue] = useState(false)

  useEffect(() => {
    setCheckValue(data.filter((item:any) => item.author_type === 3).length < 2)
  }, [data])


  const {t} = useTranslation(["admission", 'executorAdmissionSteps'])

  return (
    <Row className={`marks ${headerColor !== undefined ? `marks--${headerColor}` : ""}`}>
      <Col span={24}>
        <Row
          className={`marks__header ${headerColor !== undefined ? `marks__header--${headerColor}` : "marks__header--green"}`}
          justify="space-around">
          <Col span={23}>
            {headerTitle}
          </Col>
        </Row>

        <Row className="marks__content" justify="space-between">

          {data && data.map((item:any) => (
            <Col span={span} key={item.id}>
              <Row className="marks__item">
                <Col flex="46px">

                  <Select
                    suffixIcon={null}
                    defaultValue={item.rating}
                    popupClassName="text-center-popup"
                    disabled={disabledInput}
                    className="marks__input"
                    onChange={(value) => handleEditRating(value, item.id, selectedSpecialityId)}
                  >
                    <Option value="2">2</Option>
                    <Option value="3">3</Option>
                    <Option value="4">4</Option>
                    <Option value="5">5</Option>
                    {/*<Option value="ЗЧ">ЗЧ</Option>*/}
                    {/*<Option value="НЧ">НЧ</Option>*/}
                    {item.type === 'required' && (
                    <Option value={null}>Н</Option>
                      )}
                  </Select>

                </Col>

                {item.type === 'required' ? (
                  <Col>
                    <Text style={{fontWeight: 700}}>{item.subject_name}</Text>
                  </Col>
                ) : (
                  <Col>
                    <Text>{item.subject_name}</Text>
                  </Col>
                )}


                {canDelete && item.author_type === 3 &&
                    <DeleteOutlined
                        style={{marginLeft: 10, color: "red", cursor: "pointer"}}
                        onClick={() => handleDeleteRating(item.id)}
                    />
                }
              </Row>
            </Col>
          ))}

        </Row>

        {footerVisible && checkValue &&
            <Row className="marks__footer" justify="space-around">
                <Col className="marks__item">
                    <Button
                        className="admission__button col-green br-green"
                        onClick={() => addLessonFooterVisibleHandler({...item, type: type})}
                    >
                      {t('admission:stepsButton.add')}
                    </Button>
                </Col>
            </Row>
        }

      </Col>
    </Row>
  )
}